import { render, staticRenderFns } from "./editPayment.vue?vue&type=template&id=490e4555&"
import script from "./editPayment.vue?vue&type=script&lang=js&"
export * from "./editPayment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports